import { copyTextToClipboard } from "@pureadmin/utils";
import { useEventListener } from "@vueuse/core";
import { ElMessage } from "element-plus";

/** 文本复制指令（默认双击复制） */
export const copy = {
  mounted(el, binding) {
    const { value } = binding;
    if (value) {
      el.copyValue = value;
      const arg = binding.arg ?? "dblclick";
      // Register using addEventListener on mounted, and removeEventListener automatically on unmounted
      useEventListener(el, arg, () => {
        const success = copyTextToClipboard(el.copyValue);
        success ? ElMessage.success("复制成功") : ElMessage.error("复制失败");
      });
    } else {
      throw new Error(
        '[Directive: copy]: need value! Like v-copy="modelValue"'
      );
    }
  },
  updated(el, binding) {
    el.copyValue = binding.value;
  }
};
